import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { MailMessageService } from 'src/app/Service/MailMessage/MailMessage.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-MailMessageAdd',
  templateUrl: './MailMessageAdd.component.html',
  styleUrls: ['./MailMessageAdd.component.scss']
})
export class MailMessageAddComponent implements OnInit {

  constructor(
    private MailMessage_Service: MailMessageService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewMailMessage = new FormGroup({
      id: new FormControl(),
      Title: new FormControl(null, Validators.required),
      Dsc: new FormControl(null, Validators.required),
      LetterType: new FormControl("0", Validators.required),
    })


    this.Nav_Service.CheckValidPage(44).subscribe(
      data => {

      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewMailMessage: FormGroup;

  get_Form_Title() {
    return this.AddNewMailMessage.get('Title') as FormControl;
  }

  get_Form_Dsc() {
    return this.AddNewMailMessage.get('Dsc') as FormControl;
  }

  get_Form_LetterType() {
    return this.AddNewMailMessage.get('LetterType') as FormControl;
  }

  //#endregion

  InProccessing: boolean = false

  SubmitAddNewMailMessage() {

    if (this.get_Form_LetterType().value == "0") {
      this.Alertify_Service.ErrorMessage("نوع نامه را انتخاب نمائید")
    }
    else {
      var Record: General_Interface = Empty_General_Interface()
      Record.id = 0
      Record.title = this.get_Form_Title().value
      Record.code = this.get_Form_Dsc().value
      this.InProccessing = true
      this.MailMessage_Service.AddMail_Message(Record,Number(this.get_Form_LetterType().value) ).subscribe(
        data => {
          this.InProccessing = false
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
          }
          else {
            this.AddNewMailMessage.reset()
            this.get_Form_LetterType().setValue("0")
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }



}
